var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImgUserGrayBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    fill: "none",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EFEFEF",
    d: "M0 0h200v200H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D6D6D6",
    d: "M124.878 115.866c-6.537-4.861-12.809-8.047-14.226-8.745a.532.532 0 0 1-.303-.483v-5.788c.885-1.51 1.454-3.097 1.669-4.544.645-.051 1.48-.952 2.39-4.176 1.239-4.405-.076-5.052-1.189-4.95.215-.61.38-1.207.481-1.816 1.897-11.411-3.705-11.805-3.705-11.805s-.923-1.79-3.376-3.148c-1.632-.977-3.92-1.726-6.917-1.472-.974.05-1.897.241-2.757.533-1.1.38-2.112.927-3.035 1.561a15.928 15.928 0 0 0-3.123 2.59c-1.48 1.523-2.807 3.49-3.376 5.94-.48 1.828-.367 3.745.025 5.801.114.597.265 1.206.48 1.815-1.112-.101-2.44.546-1.188 4.95.91 3.225 1.758 4.126 2.39 4.177.227 1.46.796 3.072 1.669 4.595v5.737a.532.532 0 0 1-.304.483c-1.416.698-7.688 3.871-14.225 8.745-3.25 2.425-5.147 6.284-5.147 10.345v1.562a3.336 3.336 0 0 0 3.326 3.338H126.674a3.336 3.336 0 0 0 3.325-3.338v-1.562a12.729 12.729 0 0 0-5.121-10.345z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h200v200H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgUserGrayBg);
export default __webpack_public_path__ + "static/media/img_user_gray_bg.761caca8c9bad8bb1577177d4cfb3ac9.svg";
export { ForwardRef as ReactComponent };